"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const button_1 = require("primereact/button");
const react_1 = require("react");
const genericButton_module_scss_1 = __importDefault(require("./genericButton.module.scss"));
const tooltip_1 = require("primereact/tooltip");
const GenericButton = ({ label, icon, onClick, type = 'button', disabled = false, className, tooltip, children, }) => {
    const buttonRef = (0, react_1.useRef)(null);
    return ((0, jsx_runtime_1.jsxs)("div", { ref: buttonRef, className: "relative", children: [(0, jsx_runtime_1.jsx)(button_1.Button, { label: label, icon: icon, onClick: onClick, type: type, disabled: disabled, className: `p-button p-component ${className ?? genericButton_module_scss_1.default.buttonContainer} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}` }), tooltip && ((0, jsx_runtime_1.jsx)(tooltip_1.Tooltip, { target: buttonRef.current, content: tooltip, position: "bottom", mouseTrack: true, mouseTrackTop: 15 }))] }));
};
exports.GenericButton = GenericButton;
